import Calendar from '@ixigo/icons/Calendar';
import { InlineAlert } from '@ixigo/iui/InlineAlert';
import Input from '@ixigo/iui/Input';
import Typography from '@ixigo/iui/Typography';
import { useMemo, useRef, useState } from 'react';
import type { RideDetails } from '@/api';
import {
	DateTimePickerSheet,
	formatDateTimeLabel,
} from '@/components/date-time-picker';
import { SectionHeader } from '@/components/section-header';

interface ModifyDetailProps {
	rideDetails: RideDetails;
	note?: string; // html string
	onChange: (dateTime: string) => void;
}

export const ModifyDetail = (props: ModifyDetailProps) => {
	const { rideDetails, note, onChange } = props;
	const [showDateTimePicker, setShowDateTimePicker] = useState(false);
	const [currentDateTime, setCurrentDateTime] = useState<string>(
		rideDetails.pickup.dateTime.time,
	);
	const inputRef = useRef(false);

	const toggleDateTimePicker = () => {
		inputRef.current = false;
		setShowDateTimePicker((prev) => !prev);
	};
	const formattedDateTime = useMemo(
		() => formatDateTimeLabel(currentDateTime),
		[currentDateTime],
	);
	return (
		<div className="bg-primary p-20 flex flex-col gap-y-15">
			<SectionHeader title="Modify Detail" />
			<Input
				variant="outlined"
				label="Pickup Date & Time"
				placeholder="Select Pickup Date & Time"
				value={formattedDateTime}
				onChange={(e) => {
					const value = e.target.value;
					setCurrentDateTime(value);
					onChange(value);
				}}
				focused={inputRef.current}
				readOnly
				onClick={() => {
					setShowDateTimePicker(true);
					inputRef.current = true;
				}}
				endAdornment={<Calendar />}
			/>
			{note && (
				<InlineAlert
					title={
						<Typography
							variant="body-sm"
							/** biome-ignore lint/security/noDangerouslySetInnerHtml: <note is safe html string> */
							dangerouslySetInnerHTML={{ __html: note }}
						/>
					}
					severity="neutral"
					textColor="neutral"
				/>
			)}
			<DateTimePickerSheet
				open={showDateTimePicker}
				onClose={toggleDateTimePicker}
				defaultValue={currentDateTime}
				onConfirm={(value) => {
					setCurrentDateTime(value.toISOString());
					toggleDateTimePicker();
					onChange(value.toISOString());
				}}
			/>
		</div>
	);
};
